module.exports = __webpack_public_path__ + "img/DSC_2763-xl.b46c0f8e.png";